import { Box } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { TitleDivider } from "../titleDivider";
import { ValuationForm } from "../valuationForm";
import { observer } from "mobx-react";
import { InternalValuationReviewStore } from "../../stores/internalValuationReviewStore";
import { useUserStore } from '@roc/feature-app-core';

const useStyles = makeStyles((theme: Theme) => ({
  tabContent: {
    backgroundColor: "#FFFFFF",
    padding: "2rem",
  },
}));

interface ValuationTabProps {
  internalValuationReviewStore: InternalValuationReviewStore;
}

export const ValuationTab = observer(({ internalValuationReviewStore }: ValuationTabProps) => {
  const classes = useStyles();
  const { userStore } = useUserStore();
  const readOnly = internalValuationReviewStore.readOnly || (userStore.userInfo && userStore.userInfo.role === 'underwriter');

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap="1rem"
      className={classes.tabContent}
    >
      <TitleDivider title="Value Reconciliation" />
      <ValuationForm internalValuationReviewStore={internalValuationReviewStore} readOnly={readOnly} />
    </Box>
  );
});
